document.addEventListener('DOMContentLoaded', function () {
  const selectElement = document.getElementById('AddressCountryNew');
  const displayLanguage = document.getElementById('displayLanguage');
  const displayCurrency = document.getElementById('displayCurrency');
  const form = document.getElementById('locationForm');
  const submitButton = form.querySelector('button[type="submit"]');

  if (!selectElement || !form) return;

  const currentHost = window.location.host;

  function updateLocationInfo() {
    const selectedOption =
      selectElement.options[selectElement.selectedIndex];

    if (!selectedOption || !selectedOption.value) {
      submitButton.disabled = true;
      displayLanguage.textContent = '';
      displayCurrency.textContent = '';
      return;
    }

    const language = selectedOption.dataset.language || 'English';
    const currency = selectedOption.dataset.currency || '';

    displayLanguage.textContent = language;
    displayCurrency.textContent = currency;

    submitButton.disabled = false;
  }

  async function clearCart() {
    try {
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });
    } catch (error) {
      console.error('Error clearing cart:', error);
    }
  }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    const selectedOption =
      selectElement.options[selectElement.selectedIndex];

    if (!selectedOption || !selectedOption.value) return;

    const redirectUrl = selectedOption.dataset.url;

    if (!redirectUrl) return;

    const selectedHost = new URL(redirectUrl).host;

    submitButton.disabled = true;
    submitButton.classList.add('loading');

    // ✅ Only clear cart if changing to another store
    if (selectedHost !== currentHost) {
      await clearCart();
    }

    window.location.href = redirectUrl;
  });

  selectElement.addEventListener('change', updateLocationInfo);

  updateLocationInfo();
});